import React from "react";
import { Box, Container, Grid, Stack, Typography } from "@mui/material";
import Reveal from "../../components/Reveal";
import { STEPS } from "./content";

export default function Steps() {
  return (
    <Box id="ablauf" sx={{ pb: { xs: 8, md: 12 }, scrollMarginTop: { xs: 56, md: 72 } }}>
      <Container maxWidth="lg">
        <Stack spacing={1} sx={{ mb: 6, maxWidth: 620 }}>
          <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 2 }}>
            Ablauf
          </Typography>
          <Typography variant="h3" component="h2" fontWeight={800} letterSpacing="-0.02em">
            In drei Schritten startklar
          </Typography>
        </Stack>

        <Grid container spacing={4}>
          {STEPS.map((step, i) => (
            <Grid item xs={12} md={4} key={step.number}>
              <Reveal delay={i * 80}>
                <Box sx={{ borderTop: "3px solid", borderColor: "primary.main", pt: 2.5 }}>
                  <Typography
                    sx={{ fontSize: 44, fontWeight: 800, color: "grey.200", lineHeight: 1, mb: 1.5 }}
                  >
                    {step.number}
                  </Typography>
                  <Typography variant="h6" component="h3" fontWeight={700} sx={{ mb: 0.75 }}>
                    {step.title}
                  </Typography>
                  <Typography sx={{ color: "grey.600" }}>{step.text}</Typography>
                </Box>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
